import { createContainer } from 'react-sweet-state';

import { OnboardingStore } from './Store';

export const OnboardingStoreContainer = createContainer(OnboardingStore);
